<template>
	<div style="position: relative;" class="phbbg2">
		<div style="padding-top: 30px;text-align: right;">
			<img @click="backTo" src="../assets/phb/fanhui.png" style="width: 70px;margin-right: 5%;"/>
		</div>
		<div style="margin-top: 10px;">
			<img  src="../assets/phb/title.png" style="width: 100%;"/>
		</div>
		<div style="margin-top: -80px;">
			<div class="titlebg">{{title}}</div>
		</div>
		<div class="listdiv">
			<div class="list_item" v-for="(item,index) in list">
				
				<div style="display: flex;align-items: center;width: 70%;">
					<div v-if="index<=2" class="xuhao1">{{index+1}}</div>
					<div v-if="index>2" class="xuhao2">{{index+1}}</div>
					<img :src="item.headimg" class="headimg"/>
					<div class="nickname">{{item.nickname}}</div>
				</div>
				<div style="display: flex;align-items: center;width: 30%;justify-content: flex-end;">
					<div class="zan">{{item.zannum}}</div>
					<img src="../assets/phb/zan.png" style="width: 20px;margin-left: 5px;"/>
				</div>
			</div>
		</div>
		<div style="text-align: center;margin-top: 15px;">
			<img src="../assets/phb/tishi.png" style="width: 80%;"/>
		</div>
		<div style="width: 75%;margin: 0 auto;margin-top: 10px;">
			<div style="margin-top: 10px;">
				<input type="text" v-model="username" placeholder="姓名" class="inputdiv"/>
			</div>
			<div style="margin-top: 15px;">
				<input type="tel" v-model="phone" placeholder="电话" class="inputdiv"/>
			</div>
			<div style="margin-top: 15px;">
				<input type="text" v-model="address" placeholder="收货地址" class="inputdiv"/>
			</div>
			<div style="text-align: center;margin-top: 20px;">
				<img @click="tijiao2" src="../assets/phb/tj.png" style="width: 38%;"/>
			</div>
			
		</div>
		<div style="height: 40px;"></div>
		<div v-if="jiazai_flag" style="position: fixed;top: 0;left: 0;height: 100%;width: 100%;background-color: rgba(0,0,0,0.5);z-index: 600;">
			<div style="position: absolute;top: 45%;;width: 100%;" align="center">
				<img src="../assets/loading.gif" style="width: 30px;" />
				<!-- <div style="color: #FFFFFF;font-size: 1rem;">正在生成海报</div> -->
			</div>
		</div>
	</div>
</template>

<script>
	import Field from 'vant/lib/field';
	import 'vant/lib/field/style';
	import Vue from 'vue';
	Vue.use(Field);
	import Toast  from 'vant/lib/toast';
	import 'vant/lib/toast/style';
	
	Vue.use(Toast);
	export default {
		name: 'phbDetail',
		data() {
			return {
				ypid:null,
				title:null,
				rankid:null,
				list:[],
				
				username:null,
				phone:null,
				address:null,
				jiazai_flag:false,
			}
		},
		methods: {
			backTo(){
				console.log('backTo')
				this.$router.back()
			},
			tijiao2(){
				if (!this.username) {
					
					Toast("请填写姓名")
					return;
				} 
				if (!this.phone) {
					
					Toast("请填写手机号")
					return;
				} 
				if (!this.address) {
					
					Toast("请填写收货地址")
					return;
				} 
				
				
				if (!(/^1[3456789]\d{9}$/.test(this.phone))) {
					showtips({
					    message:"请输入正确的手机号"
					},1500);
					return;
				}
				
				var datajson = {
					"ypid":this.ypid,
					"wxopenid":wxopenid,
					"username":this.username,
					"phone":this.phone,
					"address":this.address,
				};
				datajson = JSON.stringify(datajson);
				$.ajax({
					type: "get",
					url: "https://mediaapi.hebei.com.cn/api/2025filmreview/api/zjxx_receive.php?message=" + datajson,
					datatype: "json",
					beforeSend: ()=> {
						this.jiazai_flag=true
					},
					complete: ()=> {
						this.jiazai_flag=false
					},
					//成功返回之后调用的函数
					success: (data)=> {
						console.log("data：",data)
						data = JSON.parse(data)
						if (data.code + '' == '1') {
							
							this.message=null
							this.username=null
							this.phone=null
							
							Toast("提交成功")
						} else {
							Toast(data.data)
						}
					}
				})
			}
		},
		mounted() {
			window.scroll(0,0)
			this.ypid = this.$route.query.ypid
			this.title = this.$route.query.title
			this.rankid = this.$route.query.rankid
			
			var datajson = {
				"ypid":this.ypid,
				"rankid":this.rankid
			};
			datajson = JSON.stringify(datajson);
			$.ajax({
				type: "get",
				url: "https://mediaapi.hebei.com.cn/api/2025filmreview/api/rank.php?message=" + datajson,
				datatype: "json",
				//成功返回之后调用的函数
				success: (data)=> {
					data = JSON.parse(data)
					this.list = data.data
					
				}
			})
			
		}
	}
</script>

<style>
	.phbbg2{
		background-image: url(../assets/phb/phbbg2.jpg);
		background-size: 100% 100%;
		min-height: 100vh;
	}
	.titlebg{
		color: #674224;font-size: 1.3rem;
		background-image: url(../assets/phb/titlebg.png);
		background-size: 100% 108%;
		width: 75%;
		height: 40px;
		margin: 0 auto;
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: bold;
	}
	.listdiv{
		width: 92%;
		margin: 0 auto;
		margin-top: 10px;
		border-radius: 10px;
		background-color: #ffeaba;
		padding: 0 4%;
		box-sizing: border-box;
	}
	.list_item{
		padding: 12px 0;
		border-bottom: 1px solid #db6143;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.xuhao1{
		font-size: 1.6rem;
		color: #d03c24;
		font-weight: bolder;
		width: 30px;
		text-align: center;
	}
	.xuhao2{
		font-size: 1.3rem;
		color: #d03c24;
		font-weight: bolder;
		width: 30px;
		text-align: center;
	}
	.headimg{
		width: 35px;
		border-radius: 50%;
		margin: 0 6px;
	}
	.nickname{
		font-size: 1.3rem;
		color: #ff9630;
		width: 0;
		flex: 1;
		word-break: break-all;
	}
	.zan{
		font-size: 1.3rem;
		color: #ff9630;
		width: 0;
		flex: 1;
		text-align: right;
		word-break: break-all;
	}
	.inputdiv{
		width: 100%;
		height: 40px;
		padding-left: 10px;
		box-sizing: border-box;
		line-height: 40px;
		background: #fff5df;
		outline: none;
		border: none;
		border-radius: 5px;
		color: #000;
		font-size: 1.1rem;
		
	}
	.inputdiv::placeholder{
		color: #c4b7a3;
		font-size: 1.1rem;
	}
</style>